import { Component, OnInit } from '@angular/core';
import { ActivatedRoute , Router , NavigationEnd, UrlTree} from '@angular/router';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../../app-settings';
import {SessionService} from '../../Services/session.service';
import Editor from 'egmat-ckeditor5';
import { EDITOR_TOOLBAR, EMOJI_REGEX } from 'app/models/ckeditor-config';
@Component({
  selector: 'app-user-notes',
  templateUrl: './user-notes.component.html',
  styleUrls: ['./user-notes.component.css']
})
export class UserNotesComponent implements OnInit {

  constructor(private sessionService: SessionService, private route: ActivatedRoute,private httpClientService: HttpClientService,private router:Router)
  {

  }

  editor = Editor as any;
  ckEditorConfigFocused:any  = {toolbar: EDITOR_TOOLBAR,startupFocus:true};
  ckeditorNewQueryContent:string='';
  emptyMainPost:boolean= false;
  characterExceedError:boolean = false;
  newQueryPost:boolean = false;
  editNoteFlag:boolean = false;
  emptyEditPost:boolean= false;
  characterEditExceedError:boolean = false;
  activityId:number;
  activityType:string = "ACTIVITY";
  corelationId:string;
  AllNotes:any = [];
  singleNote:any = {};
  addSingleNote = true;
  ckEditorWordsLimit:number = 3000;
  scrollToNote:boolean = false;
  loadNotesOnce:boolean = true;
  notesLoadedFlag:boolean = false;
  emptyRegex:string = '^\\s+$';
  notesMode:string = 'ACITIVITY';
  stripHTMLRegex:any = /(&nbsp;|<([^>]+)>)/ig;
  loadingCircleURL = AppSettings.cdnUrl + "assets/images/activity-loading.gif";
  ckeditorNoteContent:string = 'Completely reinvent superior e-commerce rather than wireless internal or "organic" sources. Distinctively redefine professional paradigms and superior opportunities.';
  dummyNotes:any = [{"type":"NORMAL","notes":"Completely reinvent superior e-commerce rather than wireless internal or sources. Distinctively redefine professional paradigms and superior opportunities.",
                  "id":"1"},
                  {"type":"FORUM","notesForumVO":{"forumText":"I am confused with where and when to use comma. Can you please give me some info about what should the",
                  "creationDate":"2 days ago","userName":"Bharat Gora","correlationId":"abcxyz","subjectText":"confused in verb-ing"},"id":"125"}];
  randomColors = ["#2a098d","#3d9d01","#c47439","#23c6e4","#1156de","#03254e","#5601a7","#5e1317","#27AE60","#A569BD",
                  "#df715f","#e084cd","#093c3e","#616252","#0f5d7e","#23776e","#7b789f","#aa85fc","#ac2001","#154360","#B7950B"];

  ngOnInit() {

    this.getNotesMode();

    this.sessionService.updateActivityNotes$
     .subscribe(item => { if(item != 0) {this.scrollToNote=false; this.getNotes();}}
   );

   this.sessionService.showActivityNotes$
     .subscribe(item => { if(item != 0 && this.loadNotesOnce) {this.scrollToNote=false; this.getNotes(); this.loadNotesOnce = false;}}
   );
  }

  getNotesMode()
  {
    this.route.params.subscribe(params => {
      if(params['activity'])
        {
          this.activityId = params['activity'];
          this.notesMode = 'ACTIVITY';
          
        }
        else if (params['corelationid'])
        {
            this.corelationId = params['corelationid'];
            this.notesMode = 'REVIEW';
        }
        this.AllNotes = [];
        this.loadNotesOnce = true;
        this.notesLoadedFlag = false;
      });
  }
  getNotes()
  {
    if(this.notesMode == 'ACTIVITY')
    {
        this.getActivityNotes();
        this.closeNewNoteCkEditor();
    }
    else if(this.notesMode == 'REVIEW')
    {
        this.getReviewModeData();
        if(this.scrollToNote)
        {
          this.scrollToForumNote(this.corelationId);
        }
        this.closeNewNoteCkEditor();
        this.scrollToNote = true; 
    }

  }
  getReviewModeData()
  {
    let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + 
          '/api/link/forum/'+this.corelationId+'/', headers)
      .subscribe( (data) => {
          this.activityId = data.forumObjectId;
          this.getActivityNotes();
      });
  }
  getActivityNotes()
  {
      this.blurFocus();
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + 
          '/api/notes/activity/'+this.activityId+'/', headers)
      .subscribe(
      (data) => {
        this.dummyNotes = data;
      
      var notesLength = this.dummyNotes.length;
      this.AllNotes=[];
      for(var i = 0;i<notesLength;i++)
      {
          this.singleNote = {};
          if(this.dummyNotes[i].type == "NORMAL")
          {
             this.singleNote.type = "NORMAL";
             if(this.dummyNotes[i].notes == null)
             {
               this.dummyNotes[i].notes = '';
             }
             this.singleNote.notes = this.dummyNotes[i].notes;
             this.singleNote.id = this.dummyNotes[i].id;
             this.singleNote.emptyEditPost = false;
             this.singleNote.characterEditExceedError = false;
             this.singleNote.editNoteFlag = false;
             this.singleNote.ckeditorNoteContent = this.dummyNotes[i].notes;
             this.AllNotes.push(this.singleNote);
          }
          else
          {
            if(this.dummyNotes[i].notesForumVO != null)
            {
              this.singleNote.type = "FORUM";
              if(this.dummyNotes[i].notesForumVO.forumText == null)
              {
                this.dummyNotes[i].notesForumVO.forumText = '';
              }
              this.singleNote.notes = this.dummyNotes[i].notesForumVO.forumText;
              this.singleNote.id = this.dummyNotes[i].id;
              if(this.dummyNotes[i].notesForumVO.firstName == null)
              {
                this.singleNote.userName = this.dummyNotes[i].notesForumVO.userName;
              }          
              else
              {
                this.singleNote.userName = this.dummyNotes[i].notesForumVO.firstName;
              }
              this.singleNote.letterColor = this.randomColor(this.singleNote.userName);
              this.singleNote.correlationIdURL = "/forum/"+this.dummyNotes[i].notesForumVO.correlationId;
              this.singleNote.correlationId = this.dummyNotes[i].notesForumVO.correlationId;
              this.singleNote.subjectText = this.dummyNotes[i].notesForumVO.subject;
              this.singleNote.forumPostId = this.dummyNotes[i].forumPostId;
              this.singleNote.creationDate = this.dummyNotes[i].prettyDate;
              this.AllNotes.push(this.singleNote);
            }
          }
          
      }
      this.notesLoadedFlag = true;
      });
  }
  closeNewNoteCkEditor()
  {
    this.ckeditorNewQueryContent='';
    this.emptyMainPost= false;
    this.characterExceedError = false;
    this.newQueryPost = false;
  }
  editNote(noteId,noteEditText,index)
  {
    noteEditText = (noteEditText || '').replace(EMOJI_REGEX,'');
    var newPostQuery = noteEditText.trim();
    var textQueryOnly = newPostQuery.replace(this.stripHTMLRegex,'').trim();
    if(textQueryOnly == '')
    {
        this.AllNotes[index].emptyEditPost = true;
        this.AllNotes[index].characterEditExceedError = false;
        return;
    }
    else if (textQueryOnly.length>this.ckEditorWordsLimit) 
    {
        this.AllNotes[index].characterEditExceedError = true;
        this.AllNotes[index].emptyEditPost = false;
        return;
    }
    var newNoteObject = {"objectId":this.activityId,"notes":newPostQuery};
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + 
          '/api/notes/edit/'+noteId+'/',newNoteObject, headers)
      .subscribe(
      (data) => {

        this.getActivityNotes();
        this.AllNotes[index].editNoteFlag = false;
        this.scrollToTop();
      }
      );
  }

   addNewNote()
  {
    if(!this.addSingleNote)
    {
      return;
    }
    this.ckeditorNewQueryContent =(this.ckeditorNewQueryContent || '').replace(EMOJI_REGEX,'');
    var newPostQuery = this.ckeditorNewQueryContent.trim();
    var textQueryOnly = newPostQuery.replace(this.stripHTMLRegex,'').trim();
    if(textQueryOnly == '')
    {
        this.emptyMainPost = true;
        this.characterExceedError = false;
        return;
    }
    else if (textQueryOnly.length>this.ckEditorWordsLimit) 
    {
        this.characterExceedError = true;
        this.emptyMainPost = false;
        return;
    }
    this.addSingleNote = false;
    var newNoteObject = {"objectId":this.activityId,"notes":newPostQuery,"objectType":this.activityType};
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + 
          '/api/notes/create/', newNoteObject, headers)
      .subscribe(
      (data) => {
            this.getActivityNotes();
            this.closeNewNoteCkEditor();
            this.scrollToTop();
            this.addSingleNote = true;
      }
      );
  }

  deleteNote(noteId)
  {
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + 
          '/api/notes/delete/'+noteId+'/',null, headers)
      .subscribe(
      (data) => {

          this.getActivityNotes();
      }
      );
  }
  deleteForumsNote(noteId,postId)
  {
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + 
          '/api/notes/delete/'+noteId+'/',null, headers)
      .subscribe(
      (data) => {

          this.getActivityNotes(); 
          this.sessionService.updateAddedToNotesFlag(postId);  
      }
      );
  }
  validateURL($event , corid, itemURL)
  {
    //event.preventDefault();
    if(this.corelationId)
    {
       if(corid == this.corelationId)
       {
         this.scrollToCurrentDiscussion(corid);
       }
       else
       {
         this.sessionService.updateActivityState(0);
         this.router.navigate([itemURL]);
         this.scrollToForumNote(corid);
       }
    }
    else
    {
      this.sessionService.updateActivityState(0);
      this.router.navigate([itemURL]);
    }

  }
  randomColor(userString:string):any
  {
    var firstLetterCode = userString.trim().toUpperCase().charCodeAt(0);
    var index;
    if(firstLetterCode>= 65 && firstLetterCode<=74)
    {
      index = firstLetterCode%10;
    }
    else if(firstLetterCode>= 75 && firstLetterCode<=84)
    {
      index = (firstLetterCode%10)+10;
    }
    else if(firstLetterCode>= 85 && firstLetterCode<=90)
    {
      index = firstLetterCode%10;
    }
    else
    {
      index = 1;
    }
    return this.randomColors[index];
  }
  scrollToCKEditor()
  {
    /*var scrollPos = document.getElementById('addNewNoteBtn');
    var scrollableWindow = document.getElementById('notesScrollPanel');
    var scrollheight = scrollPos.offsetTop + 400;
    var timerID = setInterval(function()
    {
        
        if( scrollableWindow.scrollTop <= 1)
        {
            clearInterval(timerID);
            return;
        }
          scrollableWindow.scrollTop  = scrollableWindow.scrollTop - 15;
    }, 5);*/
  }

  scrollToTop()
  {
    var scrollableWindow = document.getElementById('notesScrollPanel');
    var timerID = setInterval(function()
    {
        
        if( scrollableWindow.scrollTop <= 1)
        {
            clearInterval(timerID);
            return;
        }
          scrollableWindow.scrollTop  = scrollableWindow.scrollTop - 15;
    }, 5);
  }
  scrollToForumNote(corelationId)
  {
    if(corelationId != '' && corelationId != null && corelationId != undefined)
    {
      this.scrollToCurrentDiscussion(corelationId);
    }
  }
  scrollToCurrentDiscussion(corelationId)
  {
     //window.scrollTo(0, document.getElementById(this.corelationID).offsetTop);
      var forumsLocation = document.getElementById(corelationId).offsetTop;
      var body = document.body,
        html = document.documentElement;

      var height = Math.max( body.scrollHeight, body.offsetHeight,
                         html.clientHeight, html.scrollHeight, html.offsetHeight );
      var scrollheight = height - forumsLocation;
      var timerID = setInterval(function()
      {
          window.scrollBy(0, 15);
          if(window.innerHeight + window.pageYOffset >= height || window.pageYOffset >= forumsLocation || (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight-5))
              clearInterval(timerID);
      }, 5);

  }
  blurFocus()
  {
    //alert((<HTMLElement>document.activeElement).tagName+" "+(<HTMLElement>document.activeElement));
    (<any>document.body).contentEditable = true;
    (<any>document.body).contentEditable = false;
    (<HTMLElement>document.activeElement).blur();
    /*var alliFramElements = <HTMLCollection>document.getElementsByClassName("cke_wysiwyg_frame");
    var allDocs = [];
    var allCkEditors = [];
    for(let i=0; i< alliFramElements.length;i++)
    {
      allDocs[i] = (<HTMLIFrameElement>alliFramElements[i]).contentDocument || (<HTMLIFrameElement>alliFramElements[i]).contentWindow;
      allCkEditors[i] = allDocs[i].getElementsByTagName("BODY")[0];
    } 

      for(let i=0; i< allCkEditors.length;i++)
    {
       (<HTMLElement>allCkEditors[i]).blur();
       console.log(<HTMLElement>allCkEditors[i]);
    }*/
  }

}
